import { AxiosInstance } from 'axios';
import { IFacilityCapacityRepository } from '@/model/repository/manager/facility/FacilityCapacityRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): IFacilityCapacityRepository => ({
    getFacilityCapacity() {
      return Repository.get(`${resource}`);
    },
  });
